import { ExtendedUseFormReturn } from '@Hooks/index';

import { AptInput, CityInput, SameAddressCheckboxInput } from './views/inputs';
import { useBoundStore } from '@Store/index';
import { Text } from '@lili/lili-frontend-common';
import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index';
import { Line1Input } from '@Components/inputs/Line1';
import { getRouteOrdinal, RoutesMap } from '@Router/router.types';
import { useBusinessAddressAnalytics } from '@Pages/happyFlowPages/businessAddress/BusinessAddressAnalytics.tsx';
import {
  AddressStateInput,
  useHandleOnCheckedChange,
} from '@Components/inputs/AddressStateDropDown';
import { ZipInput } from '@Components/inputs/ZipAddress';
import { IBusinessAddressForm } from '@Pages/happyFlowPages/businessAddress/businessAddressForm/businessAddressSchema.tsx';

interface IBusinessAddressFormProps {
  formMethods: ExtendedUseFormReturn<IBusinessAddressForm>;
  defaultValues: IBusinessAddressForm;
}

export const BusinessAddressForm = (props: IBusinessAddressFormProps) => {
  const { reportActOnBusinessAddressScreen } = useBusinessAddressAnalytics();
  const {
    formMethods: { control, setValue, trigger, watch },
    formMethods,
    defaultValues,
  } = props;
  const baseTabIndex = getRouteOrdinal(RoutesMap.BUSINESS_ADDRESS);
  const {
    customerData: { customerAddressData },
  } = useBoundStore((state) => state.customer);
  const { line1, line2, postalCode, state, city } = customerAddressData;
  const { handleOnCheckChange } = useHandleOnCheckedChange({
    setValue,
    state,
    line1,
    city,
    postalCode,
    line2,
    trigger,
    formMethods,
    defaultValues,
  });

  const handleCheck = (isChecked: boolean) => {
    reportActOnBusinessAddressScreen(isChecked);
    handleOnCheckChange(isChecked);
  };

  const isSameAddress = watch(OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY);
  return (
    <div>
      <div className='flex w-full justify-start items-start gap-2 h-[20px] md:mb-[24px] mb-[32px]'>
        <div className='w-[16px] h-[16px] translate-y-[2px]'>
          <SameAddressCheckboxInput control={control} onChange={handleCheck} />
        </div>
        <label htmlFor={OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY}>
          <Text.H10 color='text-main-secondary' className='text-text-main-secondary'>
            {t('pages.businessAddress.checkboxText')}
          </Text.H10>
        </label>
      </div>

      <div className='w-full'>
        <Line1Input tabIndex={baseTabIndex + 1} disabled={isSameAddress} />
      </div>
      <div className='w-full'>
        <AptInput control={control} disabled={isSameAddress} />
      </div>

      <div className='w-full h-[80px] '>
        <AddressStateInput disabled={isSameAddress} tabIndex={baseTabIndex + 3} />
      </div>
      <div className='w-full'>
        <CityInput control={control} disabled={isSameAddress} />
      </div>
      <div className='w-full h-[80px]'>
        <ZipInput tabIndex={baseTabIndex + 5} disabled={isSameAddress} />
      </div>
    </div>
  );
};
